import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import { PostModel } from './NewsfeedModels';
import Post from './Posts/Post';
import PostCreation from './Posts/PostCreation';
import { useNewsfeedContext } from './NewsfeedContext';
import { useUserContext } from 'UserContext';

const Newsfeed = () => {
    const { content, loadMore, refreshContent } = useNewsfeedContext();
    const { user } = useUserContext();

    const onScroll = (event: any) => {
        const { scrollTop, scrollHeight, clientHeight } = event.nativeEvent.target;
        if (scrollTop + clientHeight >= scrollHeight - 20) {
            loadMore();
        }
    };

    const filterPosts = (post: PostModel) => {
        if (post.attachments.length) {
            const hasJobAttachment = post.attachments.some((x) => x.type === 'OngoingRequest');
            if (hasJobAttachment && post.user.id !== user?.id) {
                return false;
            }
        }

        return true;
    };

    return (
        <Grid container style={{ paddingBottom: 15 }}>
            <Text textStyle={{ marginBottom: 20, marginLeft: 5 }} variant="h1">
                Newsfeed
            </Text>
            <Grid container justify="center" style={{ overflow: 'auto', maxHeight: 1200 }} onScroll={onScroll}>
                <Grid container item>
                    <PostCreation refreshPosts={refreshContent} />
                    {content?.length > 0 ? (
                        content.filter(filterPosts).map((post) => <Post key={post.id} post={post} />)
                    ) : (
                        <Text variant="body1" bold textStyle={{ margin: 40 }}>
                            Add a post or check back soon for more news.
                        </Text>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Newsfeed;
